import { Bloc, ILoadingBloc } from "@kernel/frontend-react-app";
import { MainState, defaultMainState } from "./MainState";
import { AppConfigBloc } from "./AppConfigBloc";
import { AppLoaderBloc } from "./AppLoaderBloc";
import { INotificationHandler } from "@kernel/react-ui-kit";
import { HttpErrorNotificationHandler } from "./error";
import {
  NotificationHandler,
  NotificationHandlerProps
} from "./notifications/NotificationHandler";

export class MainBloc extends Bloc<MainState> implements ILoadingBloc {
  public static DELAY_MS = 200;
  private appConfigBloc: AppConfigBloc;
  private appLoaderBloc: AppLoaderBloc;

  private constructor(
    private error: INotificationHandler,
    private notifications: INotificationHandler
  ) {
    super(defaultMainState);
    this.appConfigBloc = AppConfigBloc.create(this);
    this.appLoaderBloc = AppLoaderBloc.create(this);
  }

  /** LOADER BLOC PROXY */
  public startLoading(title: string) {
    this.appLoaderBloc.start(title);
  }

  public stopLoading() {
    this.appLoaderBloc.stop();
  }

  /** CONFIG BLOC PROXY */
  public async loadConfigs(keys: string[]) {
    await this.appConfigBloc.load(keys);
  }

  public finish() {
    this.changeState({ ...this.state, loaded: true });
  }

  public handleError(err: unknown) {
    this.error.handle(err);
  }

  public handleNotification(props: NotificationHandlerProps) {
    this.notifications.handle(props);
  }

  public static create() {
    return new MainBloc(
      HttpErrorNotificationHandler.create(),
      NotificationHandler.create()
    );
  }

  public changeState(state: MainState) {
    super.changeState(state);
  }
}
